export const environment = {
    alias: 'memowl-prod',
    firebaseProject: 'memowl-version-2',
    sentryDsn:
        'https://8153a7855f25a83bda055ae03c8a8c66@o4508794559070208.ingest.de.sentry.io/4508794608812112',
};
